import {
  getFastagProductName,
  getHsrpProductName,
  getProductName,
} from '@components/MainWidget/ChallanWidgetLanding/helper'
import { Lob } from 'src/enums/Lob'

export const segmentEvents = {
  sem: {
    pageView: 'view_sem_page',
    widgetType: 'SEM revamp widget',
  },
  seo: {
    pageView: 'view_seo_page',
    widgetType: 'SEO revamp widget',
  },
}

export const lobSegmentEvents = {
  sem: {
    [Lob.CAR]: {
      pageView: 'view_landing_page',
    },
    [Lob.BIKE]: {
      pageView: 'view_landing_page',
    },
    [Lob.TRAVEL]: {
      pageView: 'view_sem_page',
      widgetType: 'SEM revamp widget',
    },
  },
  seo: {
    [Lob.CAR]: {
      pageView: 'view_seo_page',
      widgetType: 'SEO revamp widget',
    },
    [Lob.BIKE]: {
      pageView: 'view_seo_page',
      widgetType: 'SEO revamp widget',
    },
    [Lob.TRAVEL]: {
      pageView: 'view_seo_page',
      widgetType: 'SEO revamp widget',
    },
  },
}

export const fetchWidgetProductFn: Record<string, Function> = {
  'challan-widget-landing-page': getProductName,
  'fastag-widget-landing-page': getFastagProductName,
  'hsrp-widget-landing-page': getHsrpProductName,
}

export const widgetJourney: Record<string, string> = {
  'challan-widget-landing-page': 'challan',
  'fastag-widget-landing-page': 'fastag',
  'hsrp-widget-landing-page': 'hsrp',
}

export const fetchVasWidgetType: Record<string, string> = {
  'challan-widget-landing-page': 'SEO revamp widget',
  'fastag-widget-landing-page': 'purple widget',
  'hsrp-widget-landing-page': 'purple widget',
}
